import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createApiClient, LocalStorageTokenStorage } from '@pepi/api-client'
import { initTheme, esperarFuente } from '@pepi/ui'
import './style.css'
import App from './App.vue'
import router from './router'
import { infrastructurePlugin } from './plugins/infrastructure'

// Aplicar la apariencia (claro/oscuro/sistema) antes de montar la app
// para evitar el parpadeo inicial.
initTheme()

// Empezar a cargar la fuente (Atkinson, autoalojada) ya, y montar la app cuando
// llegue o venza el tope de 1000 ms (nunca rechaza). Sin top-level await:
// build.target es es2020, así que se monta al final con .then().
const fuente = esperarFuente()

// Inicializar cliente API con storage para web
const tokenStorage = new LocalStorageTokenStorage()
createApiClient({
  baseUrl: (import.meta as any).env.VITE_API_URL || '/api',
  apiVersion: ((import.meta as any).env.VITE_API_VERSION || 'v1').trim(),
  tokenStorage,
  timeout: 10000,
  onUnauthorized: () => {
    // Se manejará desde el auth store
    tokenStorage.clearAll()
    router.push('/login')
  }
})

// Crear la aplicación
const app = createApp(App)

// Configurar Pinia para gestión de estado
const pinia = createPinia()
app.use(pinia)

// Registrar adapters de infraestructura (storage, red, navegación, voz)
// en los puertos de @pepi/core. VA ANTES que el router: instalarlo dispara la
// navegación inicial, y su guard restaura la sesión leyendo esos puertos.
app.use(infrastructurePlugin, { router })

// Configurar router
app.use(router)

// Montar la aplicación cuando la fuente esté lista (o venza el tope)
void fuente.then(() => app.mount('#app'))
